import { showGameStateForEvent } from "../../../helpers/showGameStateForEvent";
export var getFixtureCardProps = function (state, event, cms, dict) {
    var config = state.isMiniEventCard ? state.options.dataProvider.cardConfigurationEventView : state.options.dataProvider.cardConfiguration;
    return {
        event: event,
        markets: state.displayMarkets(event.id),
        isDesktop: state.deviceDetect.isDesktop,
        sport: {
            id: event.sportId,
            config: config[event.sportId] || config[0]
        },
        handlers: {
            eventCard: state.openGameTranspiler.bind(state, event),
            betButton: state.addToSlipTranspiler.bind(state),
            favorites: state.manageFavorites.bind(state, event),
            liveStream: state.openLiveStream.bind(state, event.id),
            statistics: state.openStatTranspiler.bind(state, event.statisticsEventId)
        },
        isFavoritesEnabled: state.provider.isFavoritesEnabled,
        showMLTeamName: cms.ShowTeamNameML,
        showHeadingNames: state.isMiniEventCard ? false : state.shouldHideSubheadings,
        dict: dict,
        showLeagueInEventCard: state.showLeagueInEventCard,
        hideLowOdds: cms.HideLowOdds,
        hideGameState: showGameStateForEvent(state.options.dataProvider.disableGameStateForSportIds, event.sportId),
        showOddBtns: state.showOddBtns
    };
};
//# sourceMappingURL=getFixtureCardProps.js.map